(function (angular, app) {
    'use strict';

    var DEFAULT_SEARCH_PARAMS = {
        filters: {
            must: {
                exists: ['family.id', 'family.categoriesPaths.id', 'branch.regularPrice'],
                term: {
                    'branch.isActive': true,
                    'branch.isVisible': true
                }
            },
            mustNot: {
                term: {
                    'branch.regularPrice': 0
                }
            }
        }
    };

    var MODE_TYPES = { // Constants for mode types
        SINGLE: 1,
        CASE: 2
    };

    app.directive('spSearchAutocomplete', ['$location', '$rootScope', '$timeout', '$q', '$state', '$filter', 'Util', 'Config', 'FilterManager', 'User', 'Api', 'Cart', 'DataLayer',
        function($location, $rootScope, $timeout, $q, $state, $filter, util, Config, FilterManager, User, api, Cart, DataLayer) {
            return {
                restrict: 'E',
                replace: true,
                templateUrl: 'template/directives/sp-search-autocomplete/index.html',
                scope: {
                    model: '=spModel',
                    threshold: '=?'
                },
                controllerAs: 'searchAutoCompleteCtrl',
                controller: ['$scope', '$element', '$attrs', '$filter', function($scope, $element, $attrs, $filter) {
                    var searchAutoCompleteCtrl = this,
                        _parentElement = angular.element($element[0].parentNode || $element[0].parentElement),
                        _body = document.querySelector('body'),
                        _inputElement = angular.element(null),
                        _inputNgModelController,
                        _reloadAutoComplete,
                        _showOptionsWatcher,
                        _chosenOption,
                        _isRetailerPremiumReplacementsEnabled = Config.retailer.settings.enablePersonalReplacement,
                        _defaultOptionsCache,
                        _nameFilter = $filter('name'),
                        isRtl = Config.language.direction == 'rtl',
                        _popupAriaHiddenTimer = null,
                        _translate = $filter('translate'),
                        _visuallyHiddenCss = 'position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);border:0;padding:0;margin:0;white-space:nowrap;',
                        _inputHintEl = null,
                        _toolbarA11yHandlers = [],
                        _toolbarA11yFixTimer = null,
                        _parentKeydownBound = false;

                    searchAutoCompleteCtrl.shown = false;
                    searchAutoCompleteCtrl.highlightIndex = -1;
                    searchAutoCompleteCtrl.elementId = 'sp_search_autocomplete';
                    searchAutoCompleteCtrl.inputRequirementsHintId = 'sp_search_autocomplete_input_requirements';
                    searchAutoCompleteCtrl.brandsElementId = 'drag_to_scroll_brands';
                    searchAutoCompleteCtrl.categoriesElementId = 'drag_to_scroll_categories';
                    searchAutoCompleteCtrl.brandsElement = {};
                    searchAutoCompleteCtrl.categoriesElement = {};
                    searchAutoCompleteCtrl.searchByFilters = searchByFilters;
                    searchAutoCompleteCtrl.search = search;
                    searchAutoCompleteCtrl.startDragging = startDragging;
                    searchAutoCompleteCtrl.stopDragging = stopDragging;
                    searchAutoCompleteCtrl.moveEvent = moveEvent;
                    searchAutoCompleteCtrl.openOrderProduct = openOrderProduct;
                    searchAutoCompleteCtrl.getLine = getLine;
                    searchAutoCompleteCtrl.carouselPrev = carouselPrev;
                    searchAutoCompleteCtrl.carouselNext = carouselNext;
                    searchAutoCompleteCtrl.isHideAddButton = isHideAddButton;
                    searchAutoCompleteCtrl.openProduct = openProduct;
                    searchAutoCompleteCtrl.onModeSelectedChanged = onModeSelectedChanged;
                    searchAutoCompleteCtrl.singleCaseOptions = [{
                        id: MODE_TYPES.SINGLE,
                        name: 'Single'
                    }, {
                        id: MODE_TYPES.CASE,
                        name: 'Case'
                    }];


                    var _inputAttrs = {
                        'role': 'combobox',
                        'aria-autocomplete': 'list',
                        'aria-expanded': 'false',
                        'aria-haspopup': 'listbox',
                        'aria-owns': searchAutoCompleteCtrl.elementId,
                        'aria-controls': searchAutoCompleteCtrl.elementId
                    };

                    if (angular.isUndefined($scope.threshold)) {
                        $scope.threshold = 300;
                    }

                    _parentElement.addClass('auto-complete-wrapper');

                    var _suggestionsCountLive = document.createElement('div');
                    _suggestionsCountLive.setAttribute('role', 'status');
                    _suggestionsCountLive.setAttribute('aria-live', 'polite');
                    _suggestionsCountLive.setAttribute('aria-atomic', 'true');
                    _suggestionsCountLive.setAttribute('aria-relevant', 'text');
                    _suggestionsCountLive.style.cssText = _visuallyHiddenCss;
                    _parentElement[0].appendChild(_suggestionsCountLive);

                    function _syncInputRequirementsHintText() {
                        if (!_inputHintEl) {
                            return;
                        }
                        _inputHintEl.textContent = _translate('search_autocomplete_listbox_instructions');
                    }

                    function _ensureInputRequirementsHint() {
                        if (_inputHintEl) {
                            _syncInputRequirementsHintText();
                            return;
                        }
                        _inputHintEl = document.createElement('span');
                        _inputHintEl.id = searchAutoCompleteCtrl.inputRequirementsHintId;
                        _inputHintEl.className = 'visually-hidden';
                        _inputHintEl.style.cssText = _visuallyHiddenCss;
                        _syncInputRequirementsHintText();
                        _parentElement[0].appendChild(_inputHintEl);
                    }

                    function _mergeAriaDescribedBy(node, idToAdd) {
                        var existing;
                        var ids;
                        if (!node || !idToAdd) {
                            return;
                        }
                        existing = node.getAttribute('aria-describedby') || '';
                        ids = existing.split(/\s+/).filter(Boolean);
                        if (ids.indexOf(idToAdd) !== -1) {
                            return;
                        }
                        ids.push(idToAdd);
                        node.setAttribute('aria-describedby', ids.join(' '));
                    }

                    function _stripAriaDescribedById(node, idToRemove) {
                        var existing;
                        var ids;
                        if (!node || !idToRemove) {
                            return;
                        }
                        existing = node.getAttribute('aria-describedby');
                        if (!existing) {
                            return;
                        }
                        ids = existing.split(/\s+/).filter(function (id) {
                            return id && id !== idToRemove;
                        });
                        if (ids.length) {
                            node.setAttribute('aria-describedby', ids.join(' '));
                        } else {
                            node.removeAttribute('aria-describedby');
                        }
                    }

                    function _syncInputAriaDescribedBy() {
                        var node = _inputElement && _inputElement[0];
                        var includeHint;
                        if (!node) {
                            return;
                        }
                        includeHint = document.activeElement === node && searchAutoCompleteCtrl.highlightIndex < 0;
                        if (includeHint) {
                            _mergeAriaDescribedBy(node, searchAutoCompleteCtrl.inputRequirementsHintId);
                        } else {
                            _stripAriaDescribedById(node, searchAutoCompleteCtrl.inputRequirementsHintId);
                        }
                    }

                    _ensureInputRequirementsHint();

                    $scope.$watch(function () {
                        return Config.language && Config.language.id;
                    }, function () {
                        _syncInputRequirementsHintText();
                    });

                    function _syncAutocompletePopupAriaHidden() {
                        var root = $element[0];
                        var i;
                        var el;
                        var listboxes;
                        if (!root) {
                            return;
                        }

                        listboxes = root.querySelectorAll('[role="listbox"]');
                        var idList = [
                            searchAutoCompleteCtrl.elementId,
                            searchAutoCompleteCtrl.brandsElementId,
                            searchAutoCompleteCtrl.categoriesElementId
                        ];

                        if (!searchAutoCompleteCtrl.shown) {
                            for (i = 0; i < listboxes.length; i++) {
                                listboxes[i].removeAttribute('aria-hidden');
                            }
                            for (i = 0; i < idList.length; i++) {
                                if (!idList[i]) {
                                    continue;
                                }
                                el = root.querySelector('#' + idList[i]);
                                if (el) {
                                    el.removeAttribute('aria-hidden');
                                }
                            }
                            return;
                        }

                        for (i = 0; i < listboxes.length; i++) {
                            if (listboxes[i].id === searchAutoCompleteCtrl.elementId) {
                                continue;
                            }
                            listboxes[i].setAttribute('aria-hidden', 'true');
                        }
                        for (i = 0; i < idList.length; i++) {
                            if (!idList[i] || idList[i] === searchAutoCompleteCtrl.elementId) {
                                continue;
                            }
                            el = root.querySelector('#' + idList[i]);
                            if (el) {
                                el.setAttribute('aria-hidden', 'true');
                            }
                        }
                    }

                    function _scheduleAutocompletePopupAriaHiddenSync() {
                        if (_popupAriaHiddenTimer) {
                            $timeout.cancel(_popupAriaHiddenTimer);
                        }
                        _popupAriaHiddenTimer = $timeout(function () {
                            _popupAriaHiddenTimer = null;
                            _syncAutocompletePopupAriaHidden();
                        }, 0);
                    }

                    function _updateSuggestionsSrCount() {
                        if (!_suggestionsCountLive) {
                            return;
                        }
                        if (!searchAutoCompleteCtrl.isSearchResult) {
                            _suggestionsCountLive.textContent = '';
                            return;
                        }
                        var n = (searchAutoCompleteCtrl.products && searchAutoCompleteCtrl.products.length) || 0;
                        var msg = 'suggestion: ' + String(n);
                        _suggestionsCountLive.textContent = '';
                        $timeout(function () {
                            if (_suggestionsCountLive && searchAutoCompleteCtrl.isSearchResult) {
                                _suggestionsCountLive.textContent = msg;
                            }
                        }, 0);
                    }

                    function openProduct(product, itemsData) {
						// Helper function to create navigation promise
						function createNavigationPromise(direction, totalCount) {
							return function (index) {
								var newIndex;

								if (direction === 'previous') {
									if (index === undefined || index <= 0) {
										newIndex = totalCount;
									} else {
										newIndex = index - 1;
									}
								} else {
									// next
									if (index === undefined || index >= totalCount) {
										newIndex = 0;
									} else {
										newIndex = index + 1;
									}
								}

								itemsData.index = newIndex;
								var targetProduct = searchAutoCompleteCtrl.products[newIndex];

								return $q(function (resolve, reject) {
									if (!targetProduct) {
										reject(new Error('Product not found'));
									} else {
										openProduct(targetProduct, itemsData);
										resolve(targetProduct);
									}
								});
							};
						}

						// Set up navigation functions if conditions are met
						if (itemsData.index > 0) {
							itemsData.previous = createNavigationPromise('previous', itemsData.total);
						} else {
							itemsData.previous = undefined;
						}

						if (itemsData.index < itemsData.total) {
							itemsData.next = createNavigationPromise('next', itemsData.total);
						} else {
							itemsData.next = undefined;
						}

						util.openProduct(angular.copy(product), itemsData);
					}
                    
                    function openOrderProduct(product, index) {
                        product && util.openProduct(angular.copy(product), {
                            index: index,
                            source: $rootScope.SP_SERVICES.SOURCES.AUTOCOMPLETE_RESULTS,
                            resultsCount: searchAutoCompleteCtrl.products.length,
                            searchTerm: $scope.model
                        });
                    }

                    function isHideAddButton(item) {
                        return util.isHideAddButton(item);
                    }

                    function startDragging(event, flag, elementId, $element) {
                        var element = _getDragElement(elementId, $element);
                        searchAutoCompleteCtrl.mouseDown = true;
                        searchAutoCompleteCtrl.startX = event.pageX - element.offsetLeft;
                        searchAutoCompleteCtrl.scrollLeft = element.scrollLeft;
                    }

                    function stopDragging(event, flag) {
                        searchAutoCompleteCtrl.mouseDown = false;

                    }

                    function moveEvent(event, elementId) {
                        event.preventDefault();

                        if (!searchAutoCompleteCtrl.mouseDown) {
                            return;
                        }

                        var element = _getDragElement(elementId);
                        var x = event.pageX - element.offsetLeft;
                        var scroll = x - searchAutoCompleteCtrl.startX;
                        element.scrollLeft = searchAutoCompleteCtrl.scrollLeft - scroll;
                    }

                    function _getDragElement(elementId) {
                        if (!searchAutoCompleteCtrl[elementId]) {
                            searchAutoCompleteCtrl[elementId] =  document.getElementById(elementId || 'drag_to_scroll');
                        }

                        return searchAutoCompleteCtrl[elementId];
                    }

                    function _normalizeBrandMatchText(text) {
                        return (text || '').toString().toLowerCase().trim();
                    }

                    function _getBrandDisplayName(brand) {
                        if (!brand) {
                            return '';
                        }

                        if (!brand.id) {
                            return brand;
                        }

                        var name = _nameFilter(brand.names);

                        if (angular.isObject(name)) {
                            return name.short || name.name || name.long || '';
                        }

                        return name || '';
                    }

                    function _commonPrefixLength(a, b) {
                        var max = Math.min(a.length, b.length),
                            i = 0;

                        while (i < max && a.charAt(i) === b.charAt(i)) {
                            i++;
                        }

                        return i;
                    }

                    function _getBrandRelevanceScore(name, query) {
                        var normalizedName = _normalizeBrandMatchText(name),
                            normalizedQuery = _normalizeBrandMatchText(query),
                            brandWords,
                            queryWords,
                            score = 0,
                            fullQueryIndex,
                            i,
                            j,
                            word;

                        if (!normalizedName || !normalizedQuery) {
                            return 0;
                        }

                        if (normalizedName === normalizedQuery) {
                            return 10000;
                        }

                        if (normalizedName.indexOf(normalizedQuery) === 0) {
                            return 5000;
                        }

                        fullQueryIndex = normalizedName.indexOf(normalizedQuery);
                        if (fullQueryIndex !== -1) {
                            return 4000 - fullQueryIndex;
                        }

                        brandWords = normalizedName.split(/\s+/);
                        queryWords = normalizedQuery.split(/\s+/).filter(Boolean);

                        for (i = 0; i < queryWords.length; i++) {
                            word = queryWords[i];

                            for (j = 0; j < brandWords.length; j++) {
                                if (brandWords[j] === word) {
                                    score += 800 - (j * 10);
                                    break;
                                }

                                if (brandWords[j].indexOf(word) === 0) {
                                    score += 500 - (j * 10);
                                    break;
                                }

                                if (brandWords[j].indexOf(word) !== -1) {
                                    score += 200 - (j * 10);
                                    break;
                                }
                            }
                        }

                        if (queryWords[0] && brandWords[0]) {
                            score += _commonPrefixLength(brandWords[0], queryWords[0]) * 50;
                        }

                        return score;
                    }

                    function _sortBrandsByQueryRelevance(brands, query) {
                        if (!brands || brands.length < 2 || !query) {
                            return brands;
                        }

                        return brands.map(function (brand, index) {
                            return {
                                brand: brand,
                                index: index,
                                score: _getBrandRelevanceScore(_getBrandDisplayName(brand), query)
                            };
                        }).sort(function (a, b) {
                            if (b.score !== a.score) {
                                return b.score - a.score;
                            }

                            if ((b.brand.count || 0) !== (a.brand.count || 0)) {
                                return (b.brand.count || 0) - (a.brand.count || 0);
                            }

                            return a.index - b.index;
                        }).map(function (item) {
                            return item.brand;
                        });
                    }

                    function getOptions() {
                        var isDefaultOptions = !$scope.model || $scope.model.length < 3;
                        var params = angular.copy(DEFAULT_SEARCH_PARAMS);
                        params.from = 0;
                        params.size = 10;
                        params.query = $scope.model;
                        params.languageId = Config.language.id;
                        params.isSearch = true;
                        params.userId = User.data && User.data.id

                        if (Config.retailer.settings.enableSearchBarcode === 'true') {
                            if (util.isBarcode($scope.model)) {
                                params.barcode = $scope.model;
                                params.minScore = 0
                            }
                        }

                        if (Config.retailer.settings.showUnavailableProducts !== 'true') {
                            params.filters.mustNot.term = {
                                'branch.regularPrice': 0,
                                "branch.isOutOfStock": true
                            }
                        }
                        else {
                            if (Config.retailer.settings.isOutOfStockDuration === 'true') {
                                params.filters.bool = {
                                    "should": [
                                        {
                                            "bool": {
                                                "must_not": {
                                                    "exists": {
                                                        "field": "branch.outOfStockShowUntilDate"
                                                    }
                                                }
                                            }
                                        },
                                        {
                                            "bool": {
                                                "must": [
                                                    {
                                                    "range": {
                                                        "branch.outOfStockShowUntilDate": {
                                                        "gt": "now"
                                                        }
                                                    }
                                                    },
                                                    {
                                                    "term": {
                                                        "branch.isOutOfStock": true
                                                    }
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            "bool": {
                                                "must": [
                                                    {
                                                    "term": {
                                                        "branch.isOutOfStock": false
                                                    }
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        }
						FilterManager.parsePermanentProductTags(params, false);
                        FilterManager.parseFilters(params, []);

                        _chosenOption = $scope.model;

                        return $q.resolve().then(function () {
                            if (isDefaultOptions && !!_defaultOptionsCache) {
                                return _defaultOptionsCache;
                            }

                            return api.request({
                                url: '/v2/retailers/:rid/branches/:bid/products/autocomplete',
                                method: 'GET',
                                params: params
                            });
                        }).then(function (data) {
                            if (isDefaultOptions) {
                                _defaultOptionsCache = data;
                            }
                            searchAutoCompleteCtrl.isSearchResult = $scope.model && $scope.model.length > 2;
                            searchAutoCompleteCtrl.title = data.title && data.title[params.languageId];
                            searchAutoCompleteCtrl.customerType = data.customerType;
                            searchAutoCompleteCtrl.rules = data.suggestions && data.suggestions.rules;
                            searchAutoCompleteCtrl.products = _productsMapping(data.suggestions && data.suggestions.suggestProducts);
                            searchAutoCompleteCtrl.highlight = null;
                            searchAutoCompleteCtrl.brandsHighlight = null;
                            _clearActiveDescendant();
                            if(!searchAutoCompleteCtrl.products || searchAutoCompleteCtrl.products.length === 0) {
                                $rootScope.$emit('search.noResults', params.query);
                            }


                            if (searchAutoCompleteCtrl.isSearchResult) {
                                searchAutoCompleteCtrl.isBrandSuggestionsActive = data.isBrandSuggestionsActive;
                                searchAutoCompleteCtrl.brandSuggestionsTitle = data.brandSuggestionsTitle && data.brandSuggestionsTitle[params.languageId];
                                searchAutoCompleteCtrl.highlight = [];
                                searchAutoCompleteCtrl.brandsHighlight = [];

                                if (data.suggestions && data.suggestions.suggestFilters) {
                                    if (data.suggestions.suggestFilters.categories && data.suggestions.suggestFilters.categories.length) {
                                        Array.prototype.push.apply(searchAutoCompleteCtrl.highlight, data.suggestions.suggestFilters.categories);
                                    }

                                    if (data.suggestions.suggestFilters.brands && data.suggestions.suggestFilters.brands.length) {
                                        Array.prototype.push.apply(
                                            searchAutoCompleteCtrl.brandsHighlight,
                                            _sortBrandsByQueryRelevance(data.suggestions.suggestFilters.brands.slice(), params.query)
                                        );
                                    }
                                }
                            }
                            _updateSuggestionsSrCount();
                            _syncHighlightedRowAddToCartA11y(searchAutoCompleteCtrl.highlightIndex);
                            _scheduleAutocompletePopupAriaHiddenSync();
                        });
                    }

                    function _productsMapping(suggestProducts) {
                        var products;
                        if (suggestProducts.products) {
                            if (_isRetailerPremiumReplacementsEnabled) {
                                suggestProducts.products.forEach(function(sub) {
                                    if (sub.branch && sub.branch.isOutOfStock) {
                                        User.getReplacementSuggestions([sub.id], []).then(function(data) {
                                            if (data.length > 0 && data[0].suggestions) {
                                                sub._suggestions = data[0].suggestions
                                            }
                                        })
                                    }
                                });
                            }

                            products = suggestProducts.products;
                        } else {
                            products = (suggestProducts.items || []).map(function (item) {
                                return item && item.product || item;
                            });
                        }

                        return Cart.getProducts(products);
                    }

                    function searchByFilters(key, value, name) {
                        searchAutoCompleteCtrl.filters = {};
                        if (key && value) {
                            searchAutoCompleteCtrl.filters[key] = value;
                            $rootScope.$emit('search.filterApplied', { 
                                query: name, 
                                source: key.charAt(0).toUpperCase() + key.slice(1)
                            });
                        }
                        if(key === 'brand' && value && value[0]) {
                            searchAutoCompleteCtrl.filters = searchAutoCompleteCtrl.filters || {};
                            searchAutoCompleteCtrl.filters.queryInBrand = $scope.model;
                            searchAutoCompleteCtrl.filters.applyForSideMenu = true;
                        }

                        search('', name);
                    }

                    function search(item, title) {
                        var filter,
                            query = $scope.model;
                        if (item === 'specials') {
                            filter = 'specials';
                        } else if(searchAutoCompleteCtrl.filters && searchAutoCompleteCtrl.filters.brand) { // Search by brand - remove search term
                            query = title ? '' : item || $scope.model;
                        }

                        searchAutoCompleteCtrl.postChooseOptionClick = true;

                        $state.go('app.searchProducts', {
                            query: query,
                            filter: filter,
                            filters: searchAutoCompleteCtrl.filters || undefined,
                            sort: undefined,
                            title: title || undefined
                        });

                        searchAutoCompleteCtrl.filters = undefined
                    }


                    function _reloadOptions(setInputInFocus) {
                        if (_reloadAutoComplete) {
                            $timeout.cancel(_reloadAutoComplete);
                        }
                        searchAutoCompleteCtrl.postChooseOptionClick = false;
                        _chosenOption = null;

                        _reloadAutoComplete = $timeout(function() {
                                return getOptions().then(function () {
                                    if (setInputInFocus) {
                                        searchAutoCompleteCtrl.inFocus = true;
                                    }
                                }).catch(function(err) {
                                });
                        }, $scope.threshold);
                    }

                    function _isElementFixed(element) {
                        element = angular.element(element)[0];
                        var res = '';
                        if (window.getComputedStyle && angular.isFunction(window.getComputedStyle)) {
                            res = window.getComputedStyle(element).getPropertyValue('position');
                        } else if (element.currentStyle && element.currentStyle.position) {
                            res = element.currentStyle.position;
                        }
                        return res === 'fixed';
                    }

                    function _callSetIsOutOfScreen() {
                        $timeout(_setIsOutOfScreen, 0);
                        $timeout(_setIsOutOfScreen, 500);
                    }

                    function _setIsOutOfScreen() {
                        var currentElement = _parentElement[0],
                            top = 0;
                        do {
                            top += currentElement.offsetTop;
                            currentElement = currentElement.offsetParent;
                        } while (!!currentElement && !_isElementFixed(currentElement));

                        var bottom = top + _parentElement[0].offsetHeight + $element.prop('offsetHeight');

                        if (bottom > _body.offsetHeight) {
                            $element.addClass('out-of-screen');
                        } else {
                            $element.removeClass('out-of-screen');
                        }
                    }

                    function _apply() {
                        $scope.$applyAsync();
                    }

                    function _optionElementIdForIndex(index) {
                        var products = searchAutoCompleteCtrl.products;
                        var row;
                        var product;
                        if (!products || index < 0 || index >= products.length) {
                            return '';
                        }
                        row = products[index];
                        product = row && (row.product || row);
                        return product && product.id != null ? 'sac_opt_' + product.id : '';
                    }

                    function _resolveListboxElement() {
                        var root = $element[0];
                        var list;
                        if (!root) {
                            return document.getElementById(searchAutoCompleteCtrl.elementId);
                        }
                        list = root.querySelector('#' + searchAutoCompleteCtrl.elementId);
                        return list || root.querySelector('[role="listbox"]');
                    }

                    function _resolveOptionElement(index) {
                        var list;
                        var optId;
                        var opt;
                        var rows;

                        if (index < 0) {
                            return null;
                        }
                        list = _resolveListboxElement();
                        if (!list) {
                            return null;
                        }
                        optId = _optionElementIdForIndex(index);
                        if (optId) {
                            opt = list.querySelector('#' + optId);
                            if (opt) {
                                return opt;
                            }
                        }
                        rows = list.querySelectorAll('.autocomplete-product-row [role="option"]');
                        return rows[index] || null;
                    }

                    function _isListboxOptionElement(el, listEl) {
                        return !!(el && listEl && listEl.contains(el) && el.getAttribute('role') === 'option');
                    }

                    function _focusListboxOption(index) {
                        var opt;
                        $timeout(function () {
                            opt = _resolveOptionElement(index);
                            if (opt && typeof opt.focus === 'function') {
                                opt.focus();
                            }
                        }, 0, false);
                    }

                    function _syncHighlightedRowAddToCartA11y(activeIndex) {
                        var list;
                        var rows;
                        var i;
                        var actions;
                        var addBtn;

                        list = _resolveListboxElement();
                        if (!list) {
                            return;
                        }
                        rows = list.querySelectorAll('.autocomplete-product-row');
                        for (i = 0; i < rows.length; i++) {
                            actions = rows[i].querySelector('.product-actions');
                            if (!actions) {
                                continue;
                            }
                            addBtn = actions.querySelector('button.add-to-cart.aria-show-focus') ||
                                actions.querySelector('button.add-to-cart');
                            if (!addBtn) {
                                continue;
                            }
                            if (activeIndex >= 0 && i === activeIndex) {
                                addBtn.removeAttribute('aria-hidden');
                                addBtn.setAttribute('tabindex', '0');
                            } else {
                                addBtn.setAttribute('aria-hidden', 'true');
                                addBtn.setAttribute('tabindex', '-1');
                            }
                        }
                    }

                    function _findHighlightedRowAddToCartButton(index) {
                        var opt;
                        var row;
                        var actions;
                        var addBtn;
                        var qtyBtn;
                        var list;
                        var rows;

                        if (index < 0) {
                            return null;
                        }
                        opt = _resolveOptionElement(index);
                        row = opt && opt.closest ? opt.closest('.autocomplete-product-row') : null;
                        if (!row) {
                            list = _resolveListboxElement();
                            rows = list && list.querySelectorAll('.autocomplete-product-row');
                            row = rows && rows[index];
                        }
                        if (!row) {
                            return null;
                        }
                        actions = row.querySelector('.product-actions');
                        if (!actions) {
                            return null;
                        }
                        addBtn = actions.querySelector('button.add-to-cart');
                        if (addBtn && _isToolbarButtonVisible(addBtn)) {
                            return addBtn;
                        }
                        qtyBtn = actions.querySelector('.sp-quantity button');
                        if (qtyBtn && _isToolbarButtonVisible(qtyBtn)) {
                            return qtyBtn;
                        }
                        return addBtn || actions.querySelector('button');
                    }

                    function _scrollActiveOptionIntoListView(index) {
                        var list;
                        var opt;
                        var listRect;
                        var optRect;
                        var margin;
                        if (index < 0) {
                            return;
                        }
                        list = _resolveListboxElement();
                        opt = _resolveOptionElement(index);
                        if (!list || !opt || !list.contains(opt)) {
                            return;
                        }
                        margin = 8;
                        listRect = list.getBoundingClientRect();
                        optRect = opt.getBoundingClientRect();
                        if (optRect.top < listRect.top) {
                            list.scrollTop += (optRect.top - listRect.top) - margin;
                        } else if (optRect.bottom > listRect.bottom) {
                            list.scrollTop += (optRect.bottom - listRect.bottom) + margin;
                        }
                    }

                    function _setActiveDescendant(index) {
                        var products = searchAutoCompleteCtrl.products;
                        if (!products || !products.length || index < 0 || index >= products.length) {
                            searchAutoCompleteCtrl.highlightIndex = -1;
                            _syncHighlightedRowAddToCartA11y(-1);
                            _syncInputAriaDescribedBy();
                            return;
                        }
                        searchAutoCompleteCtrl.highlightIndex = index;
                        _syncHighlightedRowAddToCartA11y(index);
                        _syncInputAriaDescribedBy();
                        $scope.$applyAsync();
                        $timeout(function () {
                            _scrollActiveOptionIntoListView(index);
                            _focusListboxOption(index);
                        }, 0, false);
                    }

                    function _clearActiveDescendant() {
                        searchAutoCompleteCtrl.highlightIndex = -1;
                        _syncHighlightedRowAddToCartA11y(-1);
                        _syncInputAriaDescribedBy();
                    }

                    function _isArrowDownKey(event) {
                        var k = event.which || event.keyCode;
                        return k === 40 || event.key === 'ArrowDown';
                    }

                    function _isArrowUpKey(event) {
                        var k = event.which || event.keyCode;
                        return k === 38 || event.key === 'ArrowUp';
                    }

                    function _isEnterKey(event) {
                        var k = event.which || event.keyCode;
                        return k === 13 || event.key === 'Enter';
                    }

                    /**
                     * When focus is on a real control inside the listbox (Add to cart, unit switcher, etc.),
                     * Enter must activate that control — not be captured as "open highlighted option".
                     */
                    function _listboxEnterShouldDeferToFocusedControl(listEl, inputEl, ae) {
                        var tag;
                        if (!ae || ae === inputEl || !listEl || !listEl.contains(ae)) {
                            return false;
                        }
                        tag = (ae.tagName && ae.tagName.toLowerCase()) || '';
                        if (tag === 'button' || tag === 'a' || tag === 'input' || tag === 'textarea' || tag === 'select') {
                            return true;
                        }
                        return false;
                    }

                    function _toolbarEnterShouldDeferToFocusedControl(container, inputEl, ae) {
                        var resolved;
                        var clearBtn;
                        var searchBtn;
                        if (!ae || ae === inputEl || !container || !container.contains(ae)) {
                            return false;
                        }
                        resolved = _resolveSearchToolbarButtons(container, inputEl);
                        clearBtn = resolved.clearBtn;
                        searchBtn = resolved.searchBtn;
                        if (clearBtn && ae === clearBtn) {
                            return true;
                        }
                        if (searchBtn && ae === searchBtn) {
                            return true;
                        }
                        return false;
                    }

                    function _findSearchInputElement() {
                        var parent = _parentElement[0];
                        var model = $attrs.spModel;
                        var el;
                        if (!parent) {
                            return null;
                        }
                        if (model) {
                            el = parent.querySelector('input[ng-model="' + model + '"]');
                            if (el) {
                                return el;
                            }
                        }
                        el = parent.querySelector('input.search-input');
                        if (el) {
                            return el;
                        }
                        el = parent.querySelector('input[type="search"]');
                        if (el) {
                            return el;
                        }
                        return parent.querySelector('input');
                    }

                    function _shouldDeferArrowKeys(listEl, inputEl, ae) {
                        var tag;
                        var role;
                    
                        if (!ae || ae === inputEl || !listEl || !listEl.contains(ae)) {
                            return false;
                        }
                    
                        tag = (ae.tagName && ae.tagName.toLowerCase()) || '';
                        role = ae.getAttribute && ae.getAttribute('role');
                    
                        if (
                            tag === 'button' ||
                            tag === 'a' ||
                            tag === 'input' ||
                            tag === 'textarea' ||
                            tag === 'select'
                        ) {
                            return true;
                        }
                    
                        if (
                            role === 'button' ||
                            role === 'textbox' ||
                            role === 'combobox' ||
                            role === 'spinbutton' ||
                            role === 'slider'
                        ) {
                            return true;
                        }
                    
                        return false;
                    }

                    function _advanceComboboxHighlight(toAdd) {
                        var products = searchAutoCompleteCtrl.products;
                        var nextIndex;
                        var len;
                        if (!products || !products.length || !toAdd) {
                            return;
                        }
                        nextIndex = searchAutoCompleteCtrl.highlightIndex + toAdd;
                        len = products.length;
                        if (nextIndex < 0) {
                            nextIndex = len - 1;
                        } else if (nextIndex >= len) {
                            nextIndex = 0;
                        }
                        _setActiveDescendant(nextIndex);
                    }

                    /**
                     * Wrapper capture: input is a sibling of the popup, so listen on .auto-complete-wrapper.
                     * Runs in capture before scroll/default actions on input or .products overflow.
                     */
                    function _parentComboboxKeyDownCapture(event) {
                        var products;
                        var highlightIndex;
                        var toAdd;
                        var inputEl;
                        var listEl;
                        var ae;
                        var fromSearchInput;

                        if (!_parentElement[0] || !_parentElement[0].contains(event.target)) {
                            return;
                        }

                        inputEl = _inputElement && _inputElement[0];
                        if (!inputEl) {
                            return;
                        }

                        if (_isTabKey(event) || _isShiftTabKey(event)) {
                            if (_handleSearchToolbarTab(event, inputEl)) {
                                return;
                            }
                        }

                        listEl = _resolveListboxElement();
                        ae = document.activeElement;
                        fromSearchInput = event.target === inputEl;

                        toAdd = 0;
                        if (_isArrowDownKey(event)) {
                            toAdd = 1;
                        } else if (_isArrowUpKey(event)) {
                            toAdd = -1;
                        }

                        if (fromSearchInput && toAdd) {
                            event.preventDefault();
                            event.stopPropagation();
                        }

                        products = searchAutoCompleteCtrl.products;
                        if (!products || !products.length) {
                            return;
                        }

                        if (_isEnterKey(event)) {
                            if (!fromSearchInput && (
                                _listboxEnterShouldDeferToFocusedControl(listEl, inputEl, ae) ||
                                _toolbarEnterShouldDeferToFocusedControl(_parentElement[0], inputEl, ae)
                            )) {
                                return;
                            }
                            event.preventDefault();
                            event.stopPropagation();
                            highlightIndex = searchAutoCompleteCtrl.highlightIndex;
                            if (highlightIndex >= 0 && products.length > highlightIndex) {
                                searchAutoCompleteCtrl.openProduct(products[highlightIndex], {
                                    index: highlightIndex,
                                    total: products.length,
                                    source: $rootScope.SP_SERVICES.SOURCES.AUTOCOMPLETE_RESULTS,
                                    resultsCount: products.length,
                                    searchTerm: $scope.model
                                });
                            } else {
                                search();
                            }
                            $scope.$applyAsync();
                            return;
                        }

                        if (!toAdd) {
                            return;
                        }

                        if (fromSearchInput) {
                            _advanceComboboxHighlight(toAdd);
                            return;
                        }

                        if (_isListboxOptionElement(ae, listEl)) {
                            event.preventDefault();
                            event.stopPropagation();
                            if (toAdd < 0 && searchAutoCompleteCtrl.highlightIndex <= 0) {
                                _clearActiveDescendant();
                                inputEl.focus();
                                $scope.$applyAsync();
                                return;
                            }
                            _advanceComboboxHighlight(toAdd);
                            return;
                        }

                        if (!listEl || !listEl.contains(ae)) {
                            return;
                        }

                        if (_shouldDeferArrowKeys(listEl, inputEl, ae)) {
                            return;
                        }

                        event.preventDefault();
                        event.stopPropagation();
                        _advanceComboboxHighlight(toAdd);
                    }

                    function _isInsideAutocompleteListOrCarousels(el) {
                        var p = el;
                        while (p) {
                            if (p.id === searchAutoCompleteCtrl.elementId ||
                                p.id === searchAutoCompleteCtrl.brandsElementId ||
                                p.id === searchAutoCompleteCtrl.categoriesElementId) {
                                return true;
                            }
                            p = p.parentElement;
                        }
                        return false;
                    }

                    function _toolbarImgSrcLower(el) {
                        var img = el && el.querySelector && el.querySelector('img');
                        return (img && img.src) ? String(img.src).toLowerCase() : '';
                    }

                    function _toolbarSvgIconIdLower(el) {
                        var use = el && el.querySelector && el.querySelector('use');
                        var href = use && (use.getAttribute('href') || use.getAttribute('xlink:href') || '');
                        return String(href).toLowerCase();
                    }

                    function _btnLooksLikeClear(el) {
                        var src = _toolbarImgSrcLower(el);
                        var al = (el.getAttribute('aria-label') || '').toLowerCase();
                        var cls = (el.className && el.className.toString()) ? el.className.toString().toLowerCase() : '';
                        if (src.indexOf('close') !== -1 || src.indexOf('clear') !== -1 || src.indexOf('x-icon') !== -1 ||
                            src.indexOf('cancel') !== -1 || src.indexOf('delete') !== -1) {
                            return true;
                        }
                        if (al.indexOf('clear') !== -1 || al.indexOf('reset') !== -1 || al.indexOf('delete') !== -1) {
                            return true;
                        }
                        if (cls.indexOf('clear') !== -1 || cls.indexOf('reset') !== -1 || cls.indexOf('remove') !== -1) {
                            return true;
                        }
                        return false;
                    }

                    function _btnLooksLikeSearch(el) {
                        var src = _toolbarImgSrcLower(el);
                        var iconId = _toolbarSvgIconIdLower(el);
                        var al = (el.getAttribute('aria-label') || '').toLowerCase();
                        var title = (el.getAttribute('title') || '').toLowerCase();
                        var cls = (el.className && el.className.toString()) ? el.className.toString().toLowerCase() : '';
                        if (src.indexOf('search') !== -1 || src.indexOf('magnif') !== -1 || src.indexOf('loupe') !== -1 || src.indexOf('glass') !== -1) {
                            return true;
                        }
                        if (iconId.indexOf('search') !== -1 || iconId.indexOf('magnif') !== -1 || iconId.indexOf('loupe') !== -1) {
                            return true;
                        }
                        if (al.indexOf('search') !== -1 || title.indexOf('search') !== -1) {
                            return true;
                        }
                        if (cls.indexOf('search') !== -1) {
                            return true;
                        }
                        return false;
                    }

                    function _isNearSearchInputRow(el, inputNode, container) {
                        if (!el || !inputNode || !container || !container.contains(el)) {
                            return false;
                        }
                        if (inputNode.contains(el)) {
                            return false;
                        }
                        if (inputNode.parentElement && inputNode.parentElement.contains(el)) {
                            return true;
                        }
                        if (el.parentElement === container) {
                            return true;
                        }
                        return false;
                    }

                    function _collectSearchToolbarInteractives(container, inputNode) {
                        var sel = [
                            'button',
                            'a[href]',
                            '[role="button"]',
                            'div[ng-click]',
                            'span[ng-click]',
                            'div.clickable',
                            'span.clickable',
                            '[data-search-clear]'
                        ].join(', ');
                        var raw = container.querySelectorAll(sel);
                        var out = [];
                        var i;
                        var el;
                        for (i = 0; i < raw.length; i++) {
                            el = raw[i];
                            if (!el || el === inputNode) {
                                continue;
                            }
                            if (inputNode && el.contains(inputNode)) {
                                continue;
                            }
                            if (_isInsideAutocompleteListOrCarousels(el)) {
                                continue;
                            }
                            if (!_isNearSearchInputRow(el, inputNode, container)) {
                                continue;
                            }
                            out.push(el);
                        }
                        return out;
                    }

                    function _cleanupToolbarA11yHandlers() {
                        var i;
                        var h;
                        for (i = 0; i < _toolbarA11yHandlers.length; i++) {
                            h = _toolbarA11yHandlers[i];
                            if (h && h.el && h.fn) {
                                h.el.removeEventListener('keydown', h.fn);
                                h.el.removeAttribute('data-sac-keydown');
                            }
                        }
                        _toolbarA11yHandlers.length = 0;
                    }

                    function _attachToolbarEnterSpaceActivate(el) {
                        var fn;
                        if (!el || el.getAttribute('data-sac-keydown') === '1') {
                            return;
                        }
                        el.setAttribute('data-sac-keydown', '1');
                        fn = function (ev) {
                            var k = ev.key || '';
                            var code = ev.which || ev.keyCode;
                            if (k === 'Enter' || k === ' ' || code === 13 || code === 32) {
                                if (code === 32 || k === ' ') {
                                    ev.preventDefault();
                                }
                                if (typeof el.click === 'function') {
                                    el.click();
                                }
                            }
                        };
                        el.addEventListener('keydown', fn);
                        _toolbarA11yHandlers.push({ el: el, fn: fn });
                    }

                    function _ensureToolbarControlFocusable(el, isClearLike) {
                        var tag = (el.tagName || '').toLowerCase();
                        var nativeFocus = (tag === 'button' && !el.disabled) || (tag === 'a' && el.getAttribute('href'));
                        if (el.getAttribute('tabindex') === '-1') {
                            el.removeAttribute('tabindex');
                        }
                        if (!nativeFocus) {
                            if (el.tabIndex < 0 || el.getAttribute('tabindex') === null) {
                                el.setAttribute('tabindex', '0');
                            }
                            if (!el.getAttribute('role')) {
                                el.setAttribute('role', 'button');
                            }
                            _attachToolbarEnterSpaceActivate(el);
                        }
                        if (isClearLike && !el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
                            el.setAttribute('aria-label', _translate('search_autocomplete_clear_search'));
                        }
                    }

                    function _resolveSearchToolbarButtons(container, input) {
                        var list;
                        var clearBtn;
                        var searchBtn;
                        var i;
                        var b;
                        if (!container || !input) {
                            return { clearBtn: null, searchBtn: null };
                        }
                        list = _collectSearchToolbarInteractives(container, input);
                        if (!list.length) {
                            return { clearBtn: null, searchBtn: null };
                        }
                        for (i = 0; i < list.length; i++) {
                            b = list[i];
                            if (_btnLooksLikeClear(b)) {
                                clearBtn = b;
                            } else if (_btnLooksLikeSearch(b)) {
                                searchBtn = b;
                            }
                        }
                        if (!clearBtn && list.length === 2) {
                            if (list[0].getAttribute('tabindex') === '-1') {
                                clearBtn = list[0];
                                searchBtn = list[1];
                            } else if (list[1].getAttribute('tabindex') === '-1') {
                                clearBtn = list[1];
                                searchBtn = list[0];
                            } else if (_btnLooksLikeSearch(list[0]) && _btnLooksLikeClear(list[1])) {
                                clearBtn = list[1];
                                searchBtn = list[0];
                            } else if (_btnLooksLikeClear(list[0]) && _btnLooksLikeSearch(list[1])) {
                                clearBtn = list[0];
                                searchBtn = list[1];
                            } else {
                                clearBtn = list[1];
                                searchBtn = list[0];
                            }
                        }
                        if (!searchBtn && list.length === 1 && _btnLooksLikeSearch(list[0])) {
                            searchBtn = list[0];
                        }
                        if (!clearBtn && list.length === 1 && _btnLooksLikeClear(list[0])) {
                            clearBtn = list[0];
                        }
                        return { clearBtn: clearBtn, searchBtn: searchBtn };
                    }

                    function _isTabKey(event) {
                        var k = event.which || event.keyCode;
                        return k === 9 && !event.shiftKey;
                    }

                    function _isShiftTabKey(event) {
                        var k = event.which || event.keyCode;
                        return k === 9 && event.shiftKey;
                    }

                    function _isToolbarButtonVisible(btn) {
                        var style;
                        if (!btn || !btn.getClientRects) {
                            return false;
                        }
                        if (!btn.getClientRects().length) {
                            return false;
                        }
                        style = window.getComputedStyle ? window.getComputedStyle(btn) : null;
                        return !(style && (style.visibility === 'hidden' || style.display === 'none'));
                    }

                    function _handleSearchToolbarTab(event, inputEl) {
                        var ae = document.activeElement;
                        var buttons = _resolveSearchToolbarButtons(_parentElement[0], inputEl);
                        var clearBtn = buttons.clearBtn;
                        var searchBtn = buttons.searchBtn;
                        var listEl = _resolveListboxElement();
                        var addBtn;
                        var highlightIndex = searchAutoCompleteCtrl.highlightIndex;

                        if (_isShiftTabKey(event)) {
                            if (listEl && listEl.contains(ae) && ae.closest && ae.closest('.product-actions')) {
                                event.preventDefault();
                                event.stopPropagation();
                                inputEl.focus();
                                return true;
                            }
                            if (searchBtn && ae === searchBtn) {
                                event.preventDefault();
                                event.stopPropagation();
                                if (_isToolbarButtonVisible(clearBtn)) {
                                    clearBtn.focus();
                                } else {
                                    inputEl.focus();
                                }
                                return true;
                            }
                            if (clearBtn && ae === clearBtn) {
                                event.preventDefault();
                                event.stopPropagation();
                                inputEl.focus();
                                return true;
                            }
                            return false;
                        }

                        if (_isTabKey(event)) {
                            if (ae === inputEl) {
                                event.preventDefault();
                                event.stopPropagation();
                                if (highlightIndex >= 0) {
                                    addBtn = _findHighlightedRowAddToCartButton(highlightIndex);
                                    if (addBtn) {
                                        addBtn.removeAttribute('aria-hidden');
                                        addBtn.setAttribute('tabindex', '0');
                                        addBtn.focus();
                                        return true;
                                    }
                                }
                                if (_isToolbarButtonVisible(clearBtn)) {
                                    clearBtn.focus();
                                } else if (searchBtn) {
                                    searchBtn.focus();
                                }
                                return true;
                            }
                            if (clearBtn && ae === clearBtn) {
                                event.preventDefault();
                                event.stopPropagation();
                                if (searchBtn) {
                                    searchBtn.focus();
                                }
                                return true;
                            }
                        }
                        return false;
                    }

                    function _applySearchToolbarAccessibilityFix() {
                        var container = _parentElement && _parentElement[0];
                        var input = _inputElement && _inputElement[0];
                        var clearBtn;
                        var searchBtn;
                        var posFollowing = typeof Node !== 'undefined' && Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : 4;
                        var resolved;
                        if (!container || !input) {
                            return;
                        }
                        _cleanupToolbarA11yHandlers();
                        resolved = _resolveSearchToolbarButtons(container, input);
                        clearBtn = resolved.clearBtn;
                        searchBtn = resolved.searchBtn;
                        if (!clearBtn && !searchBtn) {
                            return;
                        }
                        if (clearBtn) {
                            _ensureToolbarControlFocusable(clearBtn, true);
                        }
                        if (searchBtn) {
                            _ensureToolbarControlFocusable(searchBtn, false);
                        }
                        if (clearBtn && searchBtn && (searchBtn.compareDocumentPosition(clearBtn) & posFollowing)) {
                            if (clearBtn.parentNode === searchBtn.parentNode) {
                                searchBtn.parentNode.insertBefore(clearBtn, searchBtn);
                            }
                        }
                    }

                    function _scheduleSearchToolbarAccessibilityFix() {
                        if (_toolbarA11yFixTimer) {
                            $timeout.cancel(_toolbarA11yFixTimer);
                        }
                        _toolbarA11yFixTimer = $timeout(function () {
                            _toolbarA11yFixTimer = null;
                            _applySearchToolbarAccessibilityFix();
                        }, 0);
                        $timeout(function () {
                            _applySearchToolbarAccessibilityFix();
                        }, 150);
                    }

                    function _elementFocus() {
                        searchAutoCompleteCtrl.autocompleteElementFocus = true;
                    }

                    function _inputFocus() {
                        _reloadOptions(true);
                        _apply();
                        _callSetIsOutOfScreen();
                        _syncInputAriaDescribedBy();
                    }

                    function _inputBlur() {
                        $timeout(function() {
                            //  if (searchAutoCompleteCtrl.autocompleteElementFocus || !searchAutoCompleteCtrl.inFocus || searchAutoCompleteCtrl.inFocus < 0) {
                            //     return;
                            // }


                               searchAutoCompleteCtrl.inFocus = false;
                               _syncInputAriaDescribedBy();
                        });
                    }

                    function _ensureParentKeydownListener() {
                        if (_parentKeydownBound || !_parentElement[0]) {
                            return;
                        }
                        _parentKeydownBound = true;
                        _parentElement[0].addEventListener('keydown', _parentComboboxKeyDownCapture, true);
                    }

                    function _bindInput() {
                        _ensureParentKeydownListener();
                        $element.bind('focusin', _elementFocus);
                        _inputElement.bind('focus', _inputFocus);
                        _inputElement.bind('blur', _inputBlur);

                        angular.forEach(_inputAttrs, function(value, key) {
                            _setInputAttr(key, value);
                        });
                        _syncInputAriaDescribedBy();
                        _scheduleSearchToolbarAccessibilityFix();
                    }

                    function _setInputAttr(key, value) {
                        var node = _inputElement && _inputElement[0];
                        if (!node) {
                            return;
                        }
                        if (value === null || value === undefined || value === '') {
                            node.removeAttribute(key);
                        } else {
                            node.setAttribute(key, value);
                        }
                    }

                    var watcher = $scope.$watch(function() {
                        return _findSearchInputElement();
                    }, function(newValue) {
                        if (!newValue) return;

                        watcher();
                        _inputElement = angular.element(newValue);
                        _inputNgModelController = _inputElement.data('$ngModelController');
                        _bindInput();
                    });

                    $scope.$watch('model', function(newVal) {
                        if (_chosenOption === newVal) {
                            return;
                        }

                        _reloadOptions(true);
                        _scheduleSearchToolbarAccessibilityFix();
                    });

                    var _reloadListener;

                    $scope.$on('$destroy', function() {
                        _reloadListener && _reloadListener();
                    });

                    _showOptionsWatcher = '(searchAutoCompleteCtrl.inFocus || searchAutoCompleteCtrl.autocompleteElementFocus) && !searchAutoCompleteCtrl.postChooseOptionClick';

                    $scope.$watch(_showOptionsWatcher, function(newVal) {
                        _setShown(!!newVal);
                    });

                    function _setShown(value) {
                        var prevValue = searchAutoCompleteCtrl.shown;
                        searchAutoCompleteCtrl.shown = value;
                        _setInputAttr('aria-expanded', searchAutoCompleteCtrl.shown);
                        if (searchAutoCompleteCtrl.shown) {
                            _parentElement.addClass('auto-complete-options-shown');
                        } else {
                            _parentElement.removeClass('auto-complete-options-shown');
                            _clearActiveDescendant();
                        }
                        _scheduleAutocompletePopupAriaHiddenSync();
                    }

                    util.currentScopeListener($scope, $rootScope.$on('cart.lines.add', function () {
                        if (searchAutoCompleteCtrl.products && searchAutoCompleteCtrl.products.length) {
                            angular.forEach(searchAutoCompleteCtrl.products, function (product, index) {
                                searchAutoCompleteCtrl.products[index] = Cart.getProduct(product);
                            });
                        }
                        DataLayer.push(DataLayer.EVENTS.SELECT_CONTENT, {data: {category: 'Button', action: 'Click', label: 'Add Items from search autocomplete box'}});
                    }));

                    function _onResize() {
                        _callSetIsOutOfScreen();
                    }

                    function _checkFocusElement(event) {

                        var parent = angular.element(document.querySelector(".dialog-wrapper"));
                        if (parent && !angular.isUndefined(parent[0]) && parent[0].contains(document.activeElement) || document.activeElement.id === 'main-search') {
                            return;
                        }
                        _inputBlur();
                        if (!searchAutoCompleteCtrl.autocompleteElementFocus) return;

                        var eventTarget = event && (event.target || event.srcElement || event.currentTarget);
                        searchAutoCompleteCtrl.autocompleteElementFocus = eventTarget && !!eventTarget.closest('.sp-search-autocomplete');
                    }

                    function _clearCache() {
                        _defaultOptionsCache = null;
                    }

                    function getLine(product) {
                        return util.getProductCartLine(product, product.isCaseMode);
                    }

                    function carouselPrev(elementId, options) {
                        var carouselItem = _getDragElement(elementId),
                            currentPosition = carouselItem.clientWidth + carouselItem.scrollLeft,
                            translate;

                        if (currentPosition < carouselItem.clientWidth) {
                            translate = currentPosition;
                        } else {
                            translate = (carouselItem.clientWidth);
                        }

                        options.hideNext = false;
                        carouselItem.scrollBy({ left: isRtl ? translate : translate * -1, behavior: 'smooth' });

                        $timeout(function() {
                            if (currentPosition - translate <= carouselItem.clientWidth) {
                                options.hidePrev = true;
                            }
                        });
                    }

                    function carouselNext(elementId, options) {
                        var carouselItem = _getDragElement(elementId),
                            currentPosition = carouselItem.clientWidth + carouselItem.scrollLeft,
                            translate;

                        if ((carouselItem.scrollWidth - currentPosition) < carouselItem.clientWidth) {
                            translate = carouselItem.scrollWidth - currentPosition;
                        } else {
                            translate = (carouselItem.clientWidth);
                        }

                        options.hidePrev = false;
                        if (currentPosition + translate === carouselItem.scrollWidth) {
                            options.hideNext = true;
                        }

                        carouselItem.scrollBy({ left: isRtl ? translate * -1 : translate, behavior: 'smooth' });
                    }

                    function _onHighlightChange(elementId, options, items) {
                        options.hidePrev = false;
                        options.hideNext = false;
                        options.showArrows = false;
                        $timeout(function() {
                            var element = _getDragElement(elementId);
                            if ((!element || !element.clientWidth) && items && items.length) {
                                searchAutoCompleteCtrl[elementId] = null;
                                _onHighlightChange(elementId, options, items);
                            } else if (element) {
                                element.scrollTo(0, 0);
                                options.hidePrev = true;
                                options.showArrows = element.scrollWidth > element.clientWidth;
                            }
                        });
                    }

                    /**
                     * Handles mode selection change for products
                     * @param {Object} product - The product object
                     * @param {Object} product.modeSelected - The selected mode object
                     * @param {number} product.modeSelected.id - The mode ID
                    */
                    function onModeSelectedChanged(product) {
                        
                        if (!product || !product.modeSelected) {
                            console.warn('onModeSelectedChanged: Invalid product or modeSelected parameter');
                            return;
                        }
                        product.isCaseMode = product.modeSelected.id === MODE_TYPES.CASE;
                    };

                    $scope.$watch('searchAutoCompleteCtrl.highlight', function() {
                        if (!searchAutoCompleteCtrl.highlight || !searchAutoCompleteCtrl.highlight.length) {
                            return;
                        }
                        _onHighlightChange(searchAutoCompleteCtrl.categoriesElementId, searchAutoCompleteCtrl.categoriesElement, searchAutoCompleteCtrl.highlight);
                        _scheduleAutocompletePopupAriaHiddenSync();
                    });
                    $scope.$watch('searchAutoCompleteCtrl.brandsHighlight', function() {
                        if (!searchAutoCompleteCtrl.brandsHighlight || !searchAutoCompleteCtrl.brandsHighlight.length) {
                            return;
                        }
                        _onHighlightChange(searchAutoCompleteCtrl.brandsElementId, searchAutoCompleteCtrl.brandsElement, searchAutoCompleteCtrl.brandsHighlight);
                        _scheduleAutocompletePopupAriaHiddenSync();
                    });
                    document.addEventListener('focusin', _checkFocusElement);
                    angular.element(window).bind('resize', _onResize);
                    util.currentScopeListener($scope, $scope.$root.$on('login', _clearCache));
                    util.currentScopeListener($scope, $scope.$root.$on('logout', _clearCache));

                    util.destroyListeners($scope, function() {
                        if (_toolbarA11yFixTimer) {
                            $timeout.cancel(_toolbarA11yFixTimer);
                            _toolbarA11yFixTimer = null;
                        }
                        _cleanupToolbarA11yHandlers();
                        if (_popupAriaHiddenTimer) {
                            $timeout.cancel(_popupAriaHiddenTimer);
                            _popupAriaHiddenTimer = null;
                        }
                        _setShown(false);
                        _syncAutocompletePopupAriaHidden();
                        if (_suggestionsCountLive && _suggestionsCountLive.parentNode) {
                            _suggestionsCountLive.parentNode.removeChild(_suggestionsCountLive);
                            _suggestionsCountLive = null;
                        }
                        if (_inputHintEl && _inputHintEl.parentNode) {
                            _inputHintEl.parentNode.removeChild(_inputHintEl);
                            _inputHintEl = null;
                        }
                        _stripAriaDescribedById(_inputElement && _inputElement[0], searchAutoCompleteCtrl.inputRequirementsHintId);
                        if (_parentElement && _parentElement[0]) {
                            _parentElement[0].removeEventListener('keydown', _parentComboboxKeyDownCapture, true);
                        }
                        _parentKeydownBound = false;
                        angular.element(_inputElement).unbind('focus', _inputFocus);
                        angular.element(_inputElement).unbind('blur', _inputBlur);
                        angular.element($element).unbind('focusin', _elementFocus);
                        angular.element(window).unbind('resize', _onResize);
                    });
                }]
            };
        }]);
})(angular, app);
